/*
 * @Author: Ygm
 * @Date: 2023-03-16 14:07:19
 * @LastEditors: Ygm
 * @LastEditTime: 2024-08-05 11:30:41
 * @Description:  全局注册svg组件，导入所有svg图标
 */
import Vue from 'vue'
import SvgIcon from '@/components/svgIcon/index.vue'

// register globally 全局注册
Vue.component('svg-icon', SvgIcon)
const req = require.context('@/icons', true, /\.svg$/)
const requireAll = requireContext => requireContext.keys().map(requireContext)
requireAll(req)



// WEBPACK FOOTER //
// ./src/icons/index.js